<template lang="html">
  <div
    ref="container"
    class="container"
    :style="`width:${container.width}px;height:${container.height}px;`"
  >
    <el-amap
      vid="myMap"
      :amap-manager="amapManager"
      :zoom="myMap.zoom"
      :center="myMap.center"
      :events="myMap.events"
      :plugin="myMap.plugin"
    />
  </div>
</template>

<script>
import Vue from "vue";
import VueAMap from "vue-amap";
let dataBranch = JSON.parse(localStorage.getItem("dataBranch"));
let AMapKey = "";
if (dataBranch) {
  if (dataBranch.partyGroupConfigCacheMap.amapKey_webJs) {
    AMapKey = dataBranch.partyGroupConfigCacheMap.amapKey_webJs.configValue;
  }
  if (dataBranch.partyGroupConfigCacheMap.amapKey_webJs_security) {
    window._AMapSecurityConfig = {
      securityJsCode:
        dataBranch.partyGroupConfigCacheMap.amapKey_webJs_security.configValue
    };
  }
}
VueAMap.initAMapApiLoader({
  key: AMapKey,
  plugin: [
    "AMap.Autocomplete",
    "AMap.PlaceSearch",
    "AMap.Scale",
    "AMap.OverView",
    "AMap.ToolBar",
    "AMap.MapType",
    "AMap.PolyEditor",
    "AMap.CircleEditor",
    "AMap.Geocoder",
    "AMap.Driving"
  ],
  v: "1.4.4",
  uiVersion: "1.0"
});
Vue.use(VueAMap);
import { AMapManager, lazyAMapApiLoaderInstance } from "vue-amap";
const amapManager = new AMapManager();
import { setting } from "../../../../basicInfo/menu3/vehicleTrack/MyMap4Mobile.js";
require("echarts/theme/macarons");
import "@/assets/vehicle_map/icon.css";
import { orderSite, GetRadius } from "@/api/orderform.js";
export default {
  props: {
    paranents: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      showGH: true,
      showZJ: true,
      showAPP: true,
      tryLoad: 0,
      tryLoadPlan: 0,
      loading: false,
      container: {
        width: 0,
        height: 0
      },
      amapManager,
      lazyAMapApiLoaderInstance,
      myMap: setting(this),
      geocoder: {},
      driving: {},
      markers: [],
      firstPath: "",
      linePath: [], //路径坐标数组
      passedPath: [], //经过路径坐标数组
      linePoints: [], //路径点信息数组
      startPoint: [], //起点坐标
      endPoint: [], //终点坐标
      takePoint: [], //接单点坐标
      currentPoint: {}, //路径回放，当前点位信息
      distance: 0, //路径距离
      movedDistance: 0, //移动的距离
      lineLength: 0, //路径点数组长度
      lineIndex: 0, //路径回放，当前点位序号
      lineSpeed: 100, //路径回放，当前速度
      sliderVal: 0, //路径长度移动百分比
      searchForm: {
        orderCode: "",
        radius: ""
      },
      activeName: "analyze",
      zjData: {},
      appData: {}
    };
  },
  created() {
    if (this.$route.query.orderCode) {
      this.searchForm.orderCode = this.$route.query.orderCode;
      this.getDetails();
    }
  },
  mounted() {
    let that = this;
    if (this.paranents.orderCode) {
      this.searchForm.orderCode = this.paranents.orderCode;
      this.searchForm.branchCode = this.paranents.branchCode;
      this.getDetails();
    }
    this.searchForm.radius = this.radius;
    window.onresize = function() {
      that.selfAdaption();
    };
  },
  methods: {
    getRadius() {
      GetRadius({
        orderCode: this.searchForm.orderCode
      }).then(response => {
        this.radius = response.data;
      });
    },
    getDetails() {
      this.$nextTick(function() {
        this.selfAdaption();
        this.getRadius();
        if (this.searchForm.orderCode) {
          orderSite(this.searchForm.orderCode).then(response => {
            let _this = this;
            _this.start = [
              response.data.shipperLongitude,
              response.data.shipperLatitude
            ];
            _this.end = [
              response.data.consigneeLongitude,
              response.data.consigneeLatitude
            ];
            _this.drawPlanLine(_this);
          });
        }
      });
    },
    selfAdaption() {
      this.container.width = document.documentElement.clientWidth;
      this.container.height = document.documentElement.clientHeight;
    },
    drawPlanLine(self) {
      try {
        if (!self.map) {
          //map没有初始化完成时继续等待其初始化完成
          throw "wait";
        }
        let o = amapManager.getMap();
        let circles = new AMap.Circle({
          center: self.start,
          radius: self.radius,
          fillOpacity: 0.5,
          strokeColor: "#daecfc",
          events: {
            click: () => {
              // alert('click');
            }
          }
        });
        let circles1 = new AMap.Circle({
          center: self.end,
          radius: self.radius,
          fillOpacity: 0.5,
          strokeColor: "#daecfc",
          events: {
            click: () => {
              // alert('click');
            }
          }
        });
        circles.setMap(o);
        circles1.setMap(o);
        AMap.plugin(["AMap.Driving"], function() {
          var drivingOption = {
            policy: AMap.DrivingPolicy.LEAST_TIME,
            size: 3, // 车型大小，必填，1-4分别对应小型至大型
            autoFitView: true,
            hideMarkers: true,
            map: self.map
          };
          var driving = new AMap.Driving(drivingOption); //构造驾车导航类
          driving.search(self.start, self.end, function(status, result) {
            //这里不知道为啥路线居然不用自己画。。。。。。。 = =!
            if (status === "complete") {
              /*if (result.routes && result.routes.length) {
								  self.drawRoute(self,result.routes[0]);
								  //console.log('绘制驾车路线完成')
								}*/
            } else {
              if (result == "INSUFFICIENT_ABROAD_PRIVILEGES") {
                self.$message({
                  message: "获取规划路线失败：国外权限不足！",
                  type: "error"
                });
              } else {
                self.$message({
                  message: "获取规划路线失败：" + result,
                  type: "error"
                });
              }
            }
          });
        });
      } catch (err) {
        //console.log('err', self.tryLoadPlan)
        window.setTimeout(function() {
          if (self.tryLoadPlan < 30) {
            self.drawPlanLine(self);
            self.tryLoadPlan++;
          }
        }, 200);
      }
    },
    drawRoute(self, route) {
      let path = self.parseRouteToPath(route);
      let startMarker = new AMap.Marker({
        position: path[0],
        icon: "https://webapi.amap.com/theme/v1.3/markers/n/start.png",
        map: self.map
      });
      let endMarker = new AMap.Marker({
        position: path[path.length - 1],
        icon: "https://webapi.amap.com/theme/v1.3/markers/n/end.png",
        map: self.map
      });
      let routeLine = new AMap.Polyline({
        path: path,
        isOutline: true,
        outlineColor: "#ffeeee",
        borderWeight: 2,
        strokeWeight: 5,
        strokeColor: "#ffffff",
        color: "#008000",
        lineJoin: "round"
      });
      routeLine.setMap(self.map);
      // 调整视野达到最佳显示区域
      self.map.setFitView([startMarker, endMarker, routeLine]);
    },
    parseRouteToPath(route) {
      let path = [];
      for (let i = 0, l = route.steps.length; i < l; i++) {
        let step = route.steps[i];
        for (let j = 0, n = step.path.length; j < n; j++) {
          path.push(step.path[j]);
        }
      }
      return path;
    }
  }
};
</script>
<style lang="scss" type="text/scss">
.container {
  width: 100%;
  height: 100%;
  overflow: hidden;
  .s-h-icon {
    position: absolute;
    border: 1px solid #c9cbc6;
    background-color: #f3f7f8;
    cursor: pointer;
    z-index: 1;
  }
  .c-left {
    float: left;
    width: 200px;
    height: 100%;
    border-right: 1px solid #c9cbc6;
    background-color: #f3f7f8;
    position: relative;
    .s-h-icon {
      right: -13px;
      top: 50%;
      margin-top: -16px;
      border-left: unset;
      height: 48px;
      padding: 16px 0px;
      border-radius: 0 10px 10px 0;
    }
    .c-left-menu {
      .el-form {
        padding: 10px;
        .el-form-item {
          margin-bottom: 10px;
          .el-form-item__label {
            padding: 0;
          }
        }
      }
      .searchGroup {
        padding: 10px;
      }
      .playControlGroup {
        padding: 10px;
        border-top: 1px solid #c9cbc6;
        border-bottom: 1px solid #c9cbc6;
        font-weight: bold;
        font-size: 14px;
        color: #606266;
        > div {
          padding: 0 0 10px 0;
          .el-radio-group {
            .el-radio {
              margin-right: 15px;
              .el-radio__label {
                padding-left: 2px;
              }
            }
          }
          .el-button--medium.is-circle {
            padding: 0px;
            > i {
              font-size: 30px;
            }
          }
        }
      }
    }
    .el-icon-caret-left:before {
      margin: 0 -1px 0 -3px;
      display: block;
    }
    .el-icon-caret-right:before {
      margin: 0 -1px 0 -3px;
      display: block;
    }
  }
  .c-right {
    float: right;
    height: 100%;
    .c-r-head {
      height: 60px;
      width: 100%;
      background-color: rgba(0, 0, 0, 0.4);
      position: absolute;
      z-index: 0;
    }
    .c-r-main {
      width: 100%;
      background-color: #0bb2d4;
    }
    .c-r-bottom {
      width: 100%;
      height: 200px;
      position: relative;
      .s-h-icon {
        right: 50%;
        top: -12px;
        border-bottom: unset;
        width: 48px;
        padding: 0 16px;
        border-radius: 10px 10px 0 0;
      }
      .el-icon-caret-top:before {
        margin: -2px 0 -2px 0;
        display: block;
      }
      .el-icon-caret-bottom:before {
        margin: -2px 0 -2px 0;
        display: block;
      }
      .c-bottom-menu {
        border-top: 1px solid #c9cbc6;
        background-color: #f3f7f8;
        height: 100%;
        width: 100%;
        .el-tabs {
          height: 100%;
          .el-tabs__header {
            margin-bottom: 0;
          }
          .el-tabs__content {
            height: 200px;
            .el-tab-pane {
              height: 200px;
            }
          }
        }
      }
    }
  }
  .amap-logo {
    opacity: 0;
  }
  .amap-copyright {
    opacity: 0;
  }
  .input-card {
    display: flex;
    flex-direction: column;
    min-width: 0;
    word-wrap: break-word;
    background-color: #fff;
    background-clip: border-box;
    border-radius: 0.25rem;
    width: 22rem;
    border-width: 0;
    border-radius: 0.4rem;
    box-shadow: 0 2px 6px 0 rgba(114, 124, 245, 0.5);
    position: fixed;
    bottom: 1rem;
    right: 1rem;
    -ms-flex: 1 1 auto;
    flex: 1 1 auto;
    padding: 0.75rem 1.25rem;
    z-index: 1;
    .input-item {
      position: relative;
      display: -ms-flexbox;
      display: flex;
      -ms-flex-wrap: wrap;
      flex-wrap: wrap;
      -ms-flex-align: center;
      align-items: center;
      width: 100%;
      height: 2rem;
      font-size: 14px;
      .line {
        width: 2rem;
        height: 6px;
        border: 0;
      }
    }
  }
}
</style>
